import {useEffect, useState} from "react";
import L from "leaflet";
import {useMap} from "react-leaflet";
import './Legend.scss';
import ReactDOMServer from 'react-dom/server';
import {colorGrades} from "../config";
import {Label} from "./Label";

type LegendProps =
    {
        max: number;
    }

// @ts-ignore
const Legend = ({max}: LegendProps) => {

    const map = useMap();
    const [legendAdded, setLegendAdded] = useState(false);

    useEffect(() => {
        if (map && !legendAdded && max !== 0) {

            // @ts-ignore
            const legend = L.control({position: "bottomright"});

            legend.onAdd = () => {
                const div = L.DomUtil.create("div", "info legend",);

                div.innerHTML = ReactDOMServer.renderToString(<>
                    {colorGrades.map((grade, i) => (<div key={grade}>
                        <Label from={colorGrades[i]} to={colorGrades[i + 1]} max={max}/>
                        <br/>
                    </div>))}
                </>).toString();
                return div;
            };
            map.addControl(legend);
            setLegendAdded(true);
        }
    }, [max, map, legendAdded]);
    return null;
}


export {Legend};
